module.exports = __webpack_public_path__ + "static/media/main-unlocking.50e8fc2d.png";